function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.514 6.994H0v-2h9.514L6.154 1.62 7.398.37 13 5.994l-5.602 5.624-1.244-1.25z",
  fill: "#0B0E13",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTNweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgMTMgMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ5LjMgKDUxMTY3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5hcnJvdy1yaWdodDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJTeW1ib2xzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iSWNvbnMvQXJyb3cvUmlnaHQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yLjAwMDAwMCwgLTIuMDAwMDAwKSIgZmlsbD0iIzBCMEUxMyI+CiAgICAgICAgICAgIDxnIGlkPSJhcnJvdy1yaWdodCI+CiAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iQXJyb3ciIHBvaW50cz0iMTEuNTE0NDMxNSA4Ljk5NDAwNjM4IDIgOC45OTQwMDYzOCAyIDYuOTk0MDA2MzggMTEuNTE0NDMxNSA2Ljk5NDAwNjM4IDguMTUzNjkzMTUgMy42MTk3NzkxMSA5LjM5ODQ3NjIyIDIuMzY5OTk5ODkgMTUgNy45OTQwMDYzOCA5LjM5ODQ3NjIyIDEzLjYxODAxMjkgOC4xNTM2OTMxNSAxMi4zNjgyMzM3Ij48L3BvbHlnb24+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
export { SvgComponent as ReactComponent };


// WEBPACK FOOTER //
// ./src/images/icons/arrow-right.svg